import { Icon, Textarea } from '@acpaas-ui/react-components';
import { useEffect, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { getCurrentStates, INPUT_STATES } from './forms.utils';

const getClasses = (props, state, hasError) =>
  `spo-a-textarea spo-a-textarea--${props.size} ${state.state} ${props.readOnly ? 'read-only' : ''} ${
    props.required ? 'is-required' : ''
  } ${props.description ? 'spo-a-textarea--has-description' : ''} ${
    state.isSubmitting || props.disabled ? 'has-icon-right' : ''
  } ${hasError ? 'has-error' : ''} ${props.className}`;

const TextArea = (props) => {
  const {
    label,
    value = '',
    onChange = () => {},
    onSubmit,
    onCancel = () => {},
    onEditStart = () => {},
    onKeyDown = () => {},
    state = INPUT_STATES.READ,
    hasError = false,
    required,
    placeholder,
    readOnly,
    disabled,
    description = '',
    validationError = ''
  } = props;
  const id = useRef(uuid()).current;
  const { isRead, isSubmitting, isDefault } = getCurrentStates(state);

  const handleEditStart = (e) => {
    if (!readOnly && !disabled && isRead) {
      e.stopPropagation();
      onEditStart();
    }
  };

  const handleChange = (event) => {
    onChange(event?.target?.value);
  };

  const handleKeyDown = (event) => {
    if (isDefault) {
      onKeyDown(event);
      return;
    }

    onKeyDown(event);
    if (event?.code === 'Escape') {
      onCancel();
      document.getElementById(`textarea-${id}`)?.blur?.();
    }
  };

  const [readOnlySet, setReadOnlySet] = useState(false);

  // unfortunately readOnly prop does not work on ACPaaS Textarea
  useEffect(() => {
    const textareaNode = document.getElementById(`textarea-${id}`);
    if (readOnly && !readOnlySet && textareaNode) {
      textareaNode.setAttribute('readonly', true);
      setReadOnlySet(true);
    }
  }, [id, readOnly, readOnlySet]);

  return (
    <div
      className={getClasses(props, { isSubmitting, state }, hasError || !!validationError)}
      onClick={handleEditStart}
      onKeyDown={handleKeyDown}
      onFocus={(e) => {
        if (e.target.id === `textarea-${id}`) {
          handleEditStart(e);
        }
      }}
    >
      <Textarea
        label={label}
        id={`textarea-${id}`}
        required={required}
        placeholder={placeholder}
        description={description}
        value={value}
        disabled={disabled}
        onChange={handleChange}
      />
      {(description || validationError) && (
        <div className="a-input">
          <small
            className={`${hasError || validationError ? 'u-text-danger' : ''} description u-margin-top-none`}
            id={`textarea-${id}-description`}
          >
            {validationError || description}
          </small>
        </div>
      )}
      {isSubmitting && <span className="a-spinner a-spinner--sm spinner ai"></span>}
      <div className={`actions ${isRead || isDefault ? 'hidden' : ''}`}>
        {/* ACPaaS Button doest support setting tab index */}
        <button
          className="a-button a-button--success a-button--small has-icon"
          aria-label="Submit"
          disabled={!onSubmit || isSubmitting || disabled}
          onClick={() => onSubmit?.()}
          tabIndex={isRead || isDefault ? '-1' : ''}
        >
          <Icon name="ai-check-1" />
        </button>
        <button
          className="a-button a-button--danger a-button--small a-button-outline has-icon"
          aria-label="Cancel"
          disabled={isSubmitting || disabled}
          onClick={onCancel}
          tabIndex={isRead || isDefault ? '-1' : ''}
        >
          <Icon name="ai-close" />
        </button>
      </div>
    </div>
  );
};

export default TextArea;
